import React from 'react';
import '../css/layout.css';

function FadedBackgroundLayout(props) {
  return (
    <div className="faded-background" style={{ marginTop: "-1px" }}>
      {/* Your content goes here */}
      {props.children}
    </div>
  );
}

export default FadedBackgroundLayout;
